import { useQuery } from '@apollo/client';
import { useAuthInfo } from '../routes/_app/use-auth-info.ts';
import {
  FlagsQuery,
  resolveFlagRawValue,
  resolveFlagValue,
} from './flag-query.ts';
import { FFOptions } from './flags.ts';

export const useFeatureFlags = (flag: FFOptions) => {
  const authInfo = useAuthInfo();
  const fallback =
    typeof flag.defaultEnabled === 'function'
      ? flag.defaultEnabled(authInfo)
      : flag.defaultEnabled;

  const { data } = useQuery(FlagsQuery, { fetchPolicy: 'cache-and-network' });

  if (!data) return fallback ?? false;

  return resolveFlagValue(data.flags, flag.name) ?? fallback ?? false;
};

export const useFeatureFlagRawValue = (flag: FFOptions) => {
  const { data } = useQuery(FlagsQuery, { fetchPolicy: 'cache-and-network' });

  if (!data) return flag.defaultValue ?? null;

  return (
    resolveFlagRawValue(data.flags, flag.name) ?? flag.defaultValue ?? null
  );
};
